// ================================================================================
// wp-block-language-switcher.js
// 言語切替えのスクリプトファイル
// ================================================================================

// language-switcher.js
const initLanguageSwitcher = () => {
	const buttons = document.querySelectorAll('a.js-language-switcher');
	if (!buttons.length) return;

	const closeAll = (exceptBtn = null) => {
		buttons.forEach((btn) => {
			if (exceptBtn && btn === exceptBtn) return;
			btn.classList.remove('is-open');

			const lists = btn.parentElement ? btn.parentElement.querySelector('.wp-block-language-switcher-lists') : null;
			if (!lists) return;

			if (lists.style.height === 'auto') {
				lists.style.height = `${lists.scrollHeight}px`;
				lists.getBoundingClientRect();
			}
			lists.style.height = '0px';
		});
	};

	buttons.forEach((button) => {
		const wrapper = button.parentElement;
		const lists = wrapper ? wrapper.querySelector('.wp-block-language-switcher-lists') : null;
		if (!lists) return;

		// 初期：閉じ
		button.classList.remove('is-open');
		lists.style.height = '0px';

		const open = () => {
			if (button.classList.contains('is-open')) return;
			closeAll(button);
			button.classList.add('is-open');

			lists.style.height = '0px';
			lists.getBoundingClientRect();
			lists.style.height = `${lists.scrollHeight}px`;
		};

		const close = () => {
			if (!button.classList.contains('is-open')) return;

			if (lists.style.height === 'auto') {
				lists.style.height = `${lists.scrollHeight}px`;
				lists.getBoundingClientRect();
			}
			lists.style.height = '0px';
			button.classList.remove('is-open');
		};

		button.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (button.classList.contains('is-open')) close();
			else open();
		});

		lists.addEventListener('transitionend', (e) => {
			if (e.propertyName !== 'height') return;
			if (button.classList.contains('is-open')) {
				lists.style.height = 'auto';
			}
		});
	});

	// 外側クリックで閉じる
	document.addEventListener('click', () => {
		closeAll();
	});

	// ESCで閉じる
	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') return;
		closeAll();
	});
};

document.addEventListener('DOMContentLoaded', initLanguageSwitcher);
